export class ThemeUtils {
    static isDarkMode() {
        const theme = localStorage.getItem('theme')
        return theme === 'dark';
    }

    static getTheme() {
        return localStorage.getItem('theme')
    }
}